export default "__VITE_ASSET__S$QjyZoL__"